<template #content>
  <Form
    method="dialog"
    v-slot="{ errors }"
    class="floating-labels p-1rem"
    ref="form"
  >
    <div class="row" style="margin:0 -5px">
      <div class="col-6" style="padding:0 5px">
        <selectBox
          :title="'Role'"
          v-model.number="model.RoleName"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        >
          <template #search>
            <input
              type="text"
              placeholder="Ara"
              class="form-control small"
              v-model="search.role"
            />
          </template>
          <template #input>
            <template v-for="item in roles" :key="item">
              <option
                :value="item"
                v-show="
                  item.toLowerCase().includes(search.role.toLowerCase())
                "
                >{{ item }}</option
              >
            </template>
          </template>
        </selectBox>
      </div>
      <div class="col-6" style="padding:0 5px">
        <selectBox
          :title="'Function'"
          v-model.number="model.FunctionId"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        >
          <template #search>
            <input
              type="text"
              placeholder="Ara"
              class="form-control small"
              v-model="search.function"
            />
          </template>
          <template #input>
            <template v-for="item in functions" :key="item.Id">
              <option
                :value="item.Id"
                v-show="
                  item.FunctionName.toLowerCase().includes(
                    search.function.toLowerCase()
                  )
                "
                >{{ item.FunctionName }}</option
              >
            </template>
          </template>
        </selectBox>
      </div>
    </div>
    <div class="row border-top p-1rem align-items-center" style="0 -16px -6px">
        <div class="col-auto p-0">
            <Btn
                class="btn-info btn-sm p-l-20 p-r-20 m-0"
                @click="$emit('close')"
                >Back</Btn
            >
        </div>
        <div class="col tright p-0">
        <Btn
            class="btn-success btn-md m-0"
            @click="save"
            :process="process"
            >Add Function</Btn
        >
        </div>
    </div>
  </Form>
</template>

<script>
import selectBox from "@/components/formGroup/selectBox";
export default {
  name: "Add",
  components: { selectBox },
  props: {
    roles: {
      type: Array,
      required: true,
      default: () => [],
    },
    functions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      model: {
        FunctionId: null,
        RoleName: null,
      },
      search: {
        function: "",
        role: "",   
      },
      process:false
    };
  },
  methods:{
    
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`ElektrawebRoleFunctions`,[this.model])
            .then(() => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:"The elektraweb role has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  }
};
</script>

<style></style>
